import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';

export default {
  authenticate(code) {
    return fetch(api('login'), {
      method: 'POST',
      body: JSON.stringify({ code }),
      headers: {
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => {
        Dispatcher.dispatch({
          actionType: ActionTypes.LOGIN_COMPLETED,
          token: response.token,
          refreshToken: response.refreshToken,
        });
      })
      .catch(dispatchHttpError);
  }
}
